import fetchAPI from "../fetchAPI";
const { REACT_APP_PUBLIC_URL } = process.env
//Old Code
// export async function logOut() {
//     localStorage.clear();
//     sessionStorage.clear();
//     const res = await fetchAPI("Services/react.svc/LogOut", "POST", "", false);
//     //window.location.href = `${window.origin}?ReturnPage=/${REACT_APP_PUBLIC_URL}/`;
//     window.location.href = `${window.origin}`;
// }
export async function logOut() {
    let accountId = localStorage.getItem('accountId');
    // localStorage.clear();
    // sessionStorage.clear();
    const params = new URLSearchParams(window.location.search);
    if (params.has("samlvalue")) {
        params.delete("samlvalue");
    }
    //const newUrl = window.location.origin + window.location.pathname + '?' + params.toString();
    const newUrl = window.location.origin + '/auth/login';
    window.history.replaceState({}, '', newUrl);
    // Open with out login
    // const res = await fetchAPI("Services/react.svc/LogOut", "POST", "", false);
    // window.location.href = `${window.origin}`;
    // OPen with login
    // window.location.href = `${window.origin}/beta/`;
    timeLiveLogout(Number(accountId));
    // window.location.href = `${window.origin}`;
}

const timeLiveLogout = async (accountId: Number) => {
 
    try {
        const response = await fetchAPI(`api/V2/Account/TimeLiveLogout/${accountId}`, 'Get', '', true);
    
        if (response.status === 401) {
            // Handle 401 Unauthorized
            localStorage.clear();
            sessionStorage.clear();
            window.location.href = `${window.origin}`; // Redirect to an unauthorized page or login page
        } else {
            const json = await response.json();
            if (json.message !== "") {
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = json.message;
            } else {
                localStorage.clear();
                sessionStorage.clear();
                window.location.href = `${window.origin}`;
            }
        }
    } catch (error) {
        console.error("An error occurred:", error);
        // Optionally handle network errors or other unexpected issues
    }
}